import { createContext, useContext, useEffect, useState, type ReactNode } from 'react'

/**
 * Hydration flag — řeší hydration mismatch u Motion entrance animací.
 *
 * PROBLÉM: prerender (puppeteer) nechá mount animace doběhnout, takže zapeče do HTML
 * settled stav (opacity:1). Klient ale při PRVNÍM renderu kreslí `initial` (opacity:0)
 * → hydrateRoot hlásí #418 a zahodí hydrataci celého rootu (přijdeme o rychlý FCP/LCP).
 *
 * ŘEŠENÍ: dokud není appka zhydratovaná (`useHydrated()` = false), vykresli rovnou cílový
 * (settled) stav bez vstupní animace → první render klienta se shoduje s prerenderem.
 * Po hydrataci se flag přepne na true; Motion `initial` se aplikuje jen při mountu, takže
 * už vykreslené prvky nepřeskočí, ale entrance animace naběhnou při dalších navigacích.
 */
const HydratedContext = createContext(false)

export function HydrationProvider({ children }: { children: ReactNode }) {
  const [hydrated, setHydrated] = useState(false)
  useEffect(() => { setHydrated(true) }, [])
  return <HydratedContext.Provider value={hydrated}>{children}</HydratedContext.Provider>
}

export function useHydrated(): boolean {
  return useContext(HydratedContext)
}
